/* ============================================================
   BOOKER — Serviço de índices econômicos (tempo "quase real")
   Fonte: API de Séries Temporais do Banco Central (SGS) — gratuita,
   pública e sem chave. Atualiza os índices usados nos reajustes a
   partir dos dados oficiais, com cache local e fallback.
   ============================================================ */
(function () {
  const DB = window.DB;
  const INDICES = DB.INDICES;

  /* Códigos das séries no SGS — variação mensal (%) de cada índice.
     IGP-M (FGV) = 189 · IPCA (IBGE) = 433 */
  const SERIES = {
    IGPM: { codigo: 189, fonte: 'FGV · Banco Central (SGS 189)' },
    IPCA: { codigo: 433, fonte: 'IBGE · Banco Central (SGS 433)' },
  };

  const CACHE_KEY = 'bkr-indices-cache';
  const TTL_MS = 12 * 60 * 60 * 1000; // revalida a cada 12h

  function parseNum(s) { return parseFloat(String(s).replace(',', '.')); }

  /* Acumulado de 12 meses a partir das variações mensais:
     (Π (1 + vᵢ/100) − 1) × 100 */
  function acum12De(pontos) {
    const ult = pontos.slice(-12);
    const fator = ult.reduce((f, p) => f * (1 + parseNum(p.valor) / 100), 1);
    return { acum12: +((fator - 1) * 100).toFixed(2), pontos: ult };
  }

  const apiBase = () => (window.Api && window.Api.API_BASE != null ? window.Api.API_BASE : '');

  /* Fonte primária: nosso backend (proxy do BCB) — não depende do navegador ter
     saída pra api.bcb.gov.br e compartilha o cache entre todos os usuários.
     Devolve { IGPM: {acum12, pontos, dataRef}, IPCA: {...} } ou lança. */
  async function buscarViaBackend(force, signal) {
    const r = await fetch(`${apiBase()}/api/indices${force ? '?force=1' : ''}`, { signal });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const json = await r.json();
    if (!json || !json.series) throw new Error('resposta vazia');
    return json.series;
  }

  /* Aplica os valores no objeto de índices consumido pelas telas/cálculos */
  function aplicar(key, acum12, pontos, origem, dataRef) {
    const idx = INDICES[key];
    idx.acum12 = acum12;
    if (dataRef) {
      const ano = +dataRef.split('/')[2];
      // ano corrente passa a usar o acumulado oficial nos cálculos de correção
      idx.anual = { ...idx.anual, [ano]: acum12 };
    }
    idx.historico = pontos;       // últimas 12 variações mensais (para a aba Índices)
    idx.origem = origem;          // 'api' | 'cache' | 'fallback'
    idx.fonteDado = SERIES[key].fonte;
    idx.dataRef = dataRef || idx.dataRef;
  }

  const lerCache = () => { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); } catch { return null; } };
  const salvarCache = (meta) => { try { localStorage.setItem(CACHE_KEY, JSON.stringify(meta)); } catch {} };

  let emAndamento = null;

  /* Atualiza os índices. force=true ignora o cache e vai à API. */
  async function atualizarIndices(force = false, agora = 0) {
    const cache = lerCache();

    // cache ainda válido → usa sem rede
    if (!force && cache && agora && (agora - cache.ts) < TTL_MS) {
      Object.keys(SERIES).forEach(k => {
        const c = cache.series[k];
        if (c) aplicar(k, c.acum12, c.pontos, 'cache', c.dataRef);
      });
      DB.indicesMeta = { ...cache, origem: 'cache' };
      return DB.indicesMeta;
    }
    if (emAndamento) return emAndamento;

    emAndamento = (async () => {
      const ctrl = new AbortController();
      const to = setTimeout(() => ctrl.abort(), 9000);
      const series = {};
      let algumOk = false, algumErro = false;
      const usarCache = (k) => {
        const c = cache && cache.series[k];
        if (c) { aplicar(k, c.acum12, c.pontos, 'cache', c.dataRef); series[k] = c; }
        else { INDICES[k].origem = 'fallback'; INDICES[k].fonteDado = 'valor fixo (sem conexão)'; }
      };

      try {
        const dados = await buscarViaBackend(force, ctrl.signal);   // { IGPM:{...}, IPCA:{...} }
        Object.keys(SERIES).forEach(k => {
          const d = dados[k];
          if (d && d.acum12 != null) {
            aplicar(k, d.acum12, d.pontos || [], 'api', d.dataRef);
            series[k] = { acum12: d.acum12, pontos: d.pontos || [], dataRef: d.dataRef };
            algumOk = true;
          } else { algumErro = true; usarCache(k); }
        });
      } catch (e) {
        algumErro = true;                       // backend fora → cai no cache/valor fixo
        Object.keys(SERIES).forEach(usarCache);
      }
      clearTimeout(to);

      const origem = algumOk && !algumErro ? 'api' : algumOk ? 'parcial' : (cache ? 'cache' : 'fallback');
      const meta = { ts: agora || cache?.ts || 0, origem, series };
      if (algumOk) salvarCache(meta);
      DB.indicesMeta = meta;
      emAndamento = null;
      return meta;
    })();
    return emAndamento;
  }

  // estado inicial: valores fixos do data.js servem de fallback até a 1ª busca
  Object.keys(SERIES).forEach(k => { INDICES[k].origem = 'fallback'; INDICES[k].fonteDado = SERIES[k].fonte; });
  DB.SERIES_INDICES = SERIES;
  DB.indicesMeta = { ts: 0, origem: 'pendente', series: {} };
  DB.atualizarIndices = atualizarIndices;
})();
